module.exports = __webpack_public_path__ + "static/media/Right.42b471cd.svg";